import { Directive, OnInit, inject } from '@angular/core';
import { Dialog } from 'primeng/dialog';

/**
 * Defaults aplicados a TODOS los `<p-dialog>` que importen esta directiva.
 *
 * - `draggable = false` siempre.
 * - Para modales "centrados" (default o `position="center"`) fuerza un sizing
 *   responsive uniforme: ancho fluido con margen lateral de 16px, max-width
 *   500px en desktop y max-height 80vh. Esto evita desbordes en mobile y
 *   normaliza el ancho de los modales en toda la app.
 *
 *   Importante: este sizing PISA cualquier `width`/`maxWidth`/`maxHeight`
 *   que el componente haya definido en su `[style]` inline (los anchos tipo
 *   `80vw` o `minWidth: 380px` quedaban desbordando en mobile). El resto de
 *   propiedades del `[style]` del componente se respeta.
 *
 * - Los modales con `position="bottom"`, `top`, etc. (bottom-sheets como los
 *   de dashboard) se respetan tal cual: la directiva no toca su sizing.
 */
@Directive({
  selector: 'p-dialog',
  standalone: true,
})
export class DialogDefaultsDirective implements OnInit {
  private readonly dialog = inject(Dialog);

  ngOnInit(): void {
    this.dialog.draggable = false;

    const position = this.dialog.position;
    const isCentered = !position || position === 'center';
    if (!isCentered) {
      return;
    }

    const inlineStyle = this.dialog.style ?? {};
    this.dialog.style = {
      ...inlineStyle,
      width: 'calc(100vw - 32px)',
      maxWidth: '500px',
      maxHeight: '80vh',
      minWidth: undefined,
    };
  }
}
